import { Button } from '@imprivata-cloud/components';
import { useTranslation } from 'react-i18next';
import './AuthenticatorCard.less';
import type { Authenticator, CredentialInfo } from '@api/types';
import type React from 'react';

export interface AuthenticatorCardProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  data: Authenticator | CredentialInfo;
  onRemove: (data: Authenticator | CredentialInfo) => void;
  enableRemove?: boolean;
}

const AuthenticatorCard = ({
  icon,
  title,
  subtitle,
  data,
  onRemove,
  enableRemove = true,
}: AuthenticatorCardProps) => {
  const { t } = useTranslation();
  return (
    <div className="list-card">
      <div className="list-card-icon">{icon}</div>
      <div className="list-card-content">
        <span className="list-card-title">{title}</span>
        <span className="list-card-subtitle">{subtitle}</span>
      </div>
      <div className="list-card-actions">
        {enableRemove && (
          <Button
            type="link"
            onClick={() => onRemove?.(data)}
            style={{ padding: 0, minWidth: 'auto' }}
          >
            {t('common.remove')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AuthenticatorCard;
